<!--
 * @Author: 硪要滴幸福丶 542709122@qq.com
 * @Date: 2023-02-10 11:38:24
 * @LastEditors: 硪要滴幸福丶 542709122@qq.com
 * @LastEditTime: 2023-02-10 15:28:13
 * @FilePath: \vueproject\src\views\scjx\scjxl.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
       <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>素材解析</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-view">
      <div class="search-container">
        <el-input
          v-model="query"
          @input="search"
          placeholder="请输入素材链接"
          class="search-input"
          size="large"
        ></el-input>
        <el-button class="search-button" size="large" @click="search">解析</el-button>
      </div>
      <div class="textarea-view">
        <el-input
          type="textarea"
          :rows="6"
          placeholder=""
          v-model="textarea"
          class="textarea-text">
        </el-input>
      </div>
      
  </div>
    </div>
  </template>
<script>
export default {
  data() {
    return {
      query: '',
      textarea: ''
    };
  },
  methods: {
    search() {
      // console.log(`您搜索的关键字是：${this.query}`);
    }
  }
};
</script>
<style>
.search-view {
    width: 100%;
    height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .search-container {
    display: flex;
    align-items: center;
    width: 50%;
    height: 80px;
  }

  .search-input .el-input__inner {
    height: 50px;
    font-size: 18px;
    border-radius: 25px 0 0 25px;
  }

  .search-button {
    height: 50px;
    width: 150px;    
    background-color: #007aff;
    color: #fff;
    font-size: 18px;
    border-radius: 0 25px 25px 0;
    border: none;
    cursor: pointer;
  }

  .search-button:hover {
    background-color: #0069e0;
  }

  .textarea-view{
    display:flex;
    align-items:center;
    width: 50%;
    font-size: 25px;
    color: #333;
    color: #999;
    border-color: #ddd;    
  }
</style>
  


// WEBPACK FOOTER //
// src/views/scjx/Scjx.vue